import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/lp`;

/** PACT Life Pass API for the resident website portal — every call carries the resident's rp_ token. */
export const lpApi = (token) => {
  const cfg = (params) => ({ params: { ...(params || {}), token } });
  return {
    get: (p, params) => axios.get(`${BASE}${p}`, cfg(params)).then((r) => r.data),
    post: (p, body) => axios.post(`${BASE}${p}`, body ?? {}, cfg()).then((r) => r.data),
    put: (p, body) => axios.put(`${BASE}${p}`, body, cfg()).then((r) => r.data),
    patch: (p, body) => axios.patch(`${BASE}${p}`, body, cfg()).then((r) => r.data),
    del: (p) => axios.delete(`${BASE}${p}`, cfg()).then((r) => r.data),
  };
};

export const lpErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join("; ");
  return "Something went wrong. Please try again.";
};

export const money = (n) => `${n < 0 ? "-" : ""}$${Math.abs(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (iso) => (iso ? new Date(iso).toLocaleString([], { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
export const day = (d) => (d ? new Date(`${String(d).slice(0, 10)}T12:00:00`).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" }) : "—");

export const card = "rounded-md border border-white/10 bg-white/[0.03] p-4";
export const h2 = "text-xs uppercase tracking-[0.3em] text-[#d4a017]";
export const input = "w-full rounded-md bg-black/40 border border-white/15 px-3 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-[#d4a017]/70 [color-scheme:dark]";
export const btn = "inline-flex items-center justify-center gap-1.5 rounded-md bg-[#d4a017] text-black font-semibold px-4 py-2.5 text-sm disabled:opacity-50 hover:brightness-110 transition";
export const ghost = "inline-flex items-center gap-1.5 rounded-md border border-white/15 px-3 py-2 text-xs text-white/80 hover:border-white/40";
